import React, { FC } from 'react'
import { BasicInfo } from 'types'

export interface ITabsPanelV2Props {
  tabs: BasicInfo[]
  activeTabName: string
  onChange: (args: BasicInfo) => void
  className?: string
}

export const TabsPanelV2: FC<ITabsPanelV2Props> = ({
  tabs,
  activeTabName,
  onChange,
  className = '',
}) => {
  const isActiveTab = (tab: BasicInfo) => tab.name === activeTabName || ''

  return (
    <div className={`${className} flex`}>
      <ul className="flex items-center w-full">
        {tabs?.map((tab, key) => {
          return (
            <li
              className={`${
                isActiveTab(tab)
                  ? 'border-b-primary-brandBlueLight border-b-[3px] text-primary-brandBlueLight '
                  : 'text-primary border-b-primary-disabled border-b-[1px]'
              } cursor-pointer whitespace-nowrap leading-5 font-[650] text-base py-4 text-center border-collapse flex-grow`}
              key={key}
              onClick={() => onChange(tab)}
            >
              {tab?.title}
            </li>
          )
        })}
      </ul>
      <div className="border-b-primary-disabled border-b-[1px] sm:w-3/6 md:w-4/6 mdl:w-full	mb-[1px]" />
    </div>
  )
}

export default TabsPanelV2
